import type { NavNode } from "@/lib/dto";
import type { MenuSettings } from "./MobileMenu";
import { MailIcon, MapPin, PhoneIcon } from "lucide-react";
import React from "react";
import { Button } from "../../ui/Button";
import Collapse from "./Collapse";

interface MobileNavProps {
  settings: MenuSettings;
  items: NavNode[];
  open: boolean;
  onClose: () => void;
}

const MobileNav: React.FC<MobileNavProps> = ({
  settings,
  items,
  open,
  onClose,
}) => {
  const { phone, email, address } = settings.contact ?? {};

  return (
    <>
      <div
        id="mobile-navigation"
        className={
          open
            ? "mobile-navigation mobile-navigation-active"
            : "mobile-navigation"
        }
      >
        <div className="navigation-inner">
          <ul>
            {items.map((itm) => {
              const { href, label, children } = itm;
              return (
                <Collapse
                  href={href}
                  title={label}
                  key={itm.id}
                  onNavigate={onClose}
                >
                  {children && children.length >= 1 && (
                    <ul>
                      {children.map((child) => (
                        <Collapse
                          href={child.href}
                          title={child.label}
                          key={child.id}
                          onNavigate={onClose}
                        >
                          {child.children && child.children.length >= 1 && (
                            <ul>
                              {child.children.slice(0, 11).map((grandchild) => (
                                <Collapse
                                  href={grandchild.href}
                                  title={grandchild.label}
                                  key={grandchild.id}
                                  onNavigate={onClose}
                                ></Collapse>
                              ))}
                            </ul>
                          )}
                        </Collapse>
                      ))}
                    </ul>
                  )}
                </Collapse>
              );
            })}
          </ul>
        </div>

        <div className="mobile-navigation-foot">
          <Button
            variant="primary"
            href="/contact-us"
            onClick={onClose}
            className="w-full uppercase"
            arrow
          >
            Contact Us
          </Button>

          <ul className="mobile-navigation-contact">
            {phone && (
              <li>
                <a href={`tel:${phone.replace(/\s+/g, "")}`}>
                  <PhoneIcon size={15} aria-hidden />
                  <span>{phone}</span>
                </a>
              </li>
            )}
            {email && (
              <li>
                <a href={`mailto:${email}`}>
                  <MailIcon size={15} aria-hidden />
                  <span>{email}</span>
                </a>
              </li>
            )}
            {address && (
              <li>
                <MapPin size={15} aria-hidden />
                <span>{address}</span>
              </li>
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default MobileNav;
